document.addEventListener('DOMContentLoaded', function () {
  init();
});

window.addEventListener('resize', function(event) {
  init();
});

document.addEventListener('splide:loaded', (event) => {
  init();
});

function init() {
  setTimeout(() => {
    setUniformHeight('.product-card__image');
    setUniformHeight('.product-card__title');
    setUniformHeight('.product-card__description');
  }, 300);
}

function setUniformHeight(selector) {
  const elements = document.querySelectorAll(selector);
  const grid = document.querySelector('.azantic-product-grid');
  if (!grid || elements.length === 0) return;

  const columnsMobile = parseInt(grid.getAttribute('data-columns-mobile'), 10);
  const columnsDesktop = parseInt(grid.getAttribute('data-columns-desktop'), 10);

  // Device type
  const isMobile = window.innerWidth < 750;
  const columns = isMobile ? columnsMobile : columnsDesktop;

  // If columns are undefined, apply uniform height for all elements
  if (!columns || isNaN(columns)) {
    let maxHeight = 0;
    elements.forEach((element) => {
      element.style.removeProperty('height');
      maxHeight = Math.max(maxHeight, element.offsetHeight);
    });
    elements.forEach((element) => {
      element.style.height = `${maxHeight}px`;
    });
    return;
  }

  // Apply row-based uniform height
  for (let i = 0; i < elements.length; i += columns) {
    const rowElements = Array.from(elements).slice(i, i + columns);

    // Reset heights for the row
    rowElements.forEach((element) => {
      element.style.removeProperty('height');
    });

    const maxHeight = rowElements.reduce((max, element) => {
      return Math.max(max, element.offsetHeight);
    }, 0);

    rowElements.forEach((element) => {
      element.style.height = `${maxHeight}px`;
    });
  }
}
